export const colors: string[] = [
  "#475569", // slate-600
  "#37c5ef",
  "#1b79db",
  "#c38e61",
  "#00b400",
  "#6b8a47",
  "#7e6049",
  "#e77899",
  "#9a5399",
  "#77c8bf",
  "#942f33",
  "#ff007f",
  "#813d32",
  "#434343",
  "#ff0080",
  "#57534e", // stone-600
  "#dc2626", // red-600
  "#ea580c", // orange-600
  "#d97706", // amber-600
  "#ca8a04", // yellow-600
  "#65a30d", // lime-600
  "#16a34a", // green-600
  "#059669", // emerald-600
  "#0d9488", // teal-600
  "#0891b2", // cyan-600
  "#0284c7", // sky-600
  "#2563eb", // blue-600
  "#4f46e5", // indigo-600
  "#7c3aed", // violet-600
  "#9333ea", // purple-600
  "#c026d3", // fuchsia-600
  "#db2777", // pink-600
  "#e11d48", // rose-600
];
